import { Mui } from "@osu/react-ui";
import { useGetSystemMessageQuery, useUpdateSystemMessageMutation } from "../../../services/shared/api";
import TextField from "./TextField";

const textFieldName = "alert-sys-msg-name";

const createAlertProps = ({ isError, isLoading, isSuccess }) => {
  const alertProps = {};
  if (isError) {
    alertProps.severity = "error";
    alertProps.children = "An error occurred. Please try to publish again.";
  } else if (isLoading) {
    alertProps.severity = "info";
    alertProps.children = "Setting system alert message...";
  } else if (isSuccess) {
    alertProps.severity = "success";
    alertProps.children = `System alert message properly set.`;
  }

  if (alertProps.children) {
    alertProps.component = Mui.Alert;
    alertProps.sx = {
      mb: 3,
      width: "100%",
    };
  }
  return alertProps;
};


function Form({ id = "system-message-form", ...props }) {
  const [generateMessage, { isError, isLoading, isSuccess }] =
    useUpdateSystemMessageMutation();
    const { data } = useGetSystemMessageQuery(undefined, {
      refetchOnMountOrArgChange: true
    })

  const onSubmit = (event) => {
    event.preventDefault();
    const formValues = new FormData(event.currentTarget)
    const message = formValues.get(textFieldName)
    generateMessage(message || "");
  };

  const alertProps = createAlertProps({ isError, isLoading, isSuccess });

  return (
    <Mui.Box id={id} {...props} component="form" onSubmit={onSubmit}>
      <Mui.Box
        role="status"
        aria-live="polite"
        aria-atomic="true"
        {...alertProps}
      />
      <TextField defaultValue={data?.message || ""} name={textFieldName} />
      <Mui.Button disabled={isLoading} variant="outlined" sx={{ mt: 2 }} type="submit">
        {isLoading ? "Publishing..." : "Publish"}
      </Mui.Button>
    </Mui.Box>
  );
}

export default Form;
